import { formatBps, milestoneAnniversary } from '../../domain/equityEngine';
import type { MilestoneCalculation, Scenario } from '../../domain/types';

interface TimelineProps {
  calculation: MilestoneCalculation;
  scenario: Scenario;
}

export function Timeline({ calculation, scenario }: TimelineProps) {
  const milestone = calculation.milestone;
  const nodes = [
    {
      label: '里程碑达成',
      date: milestone.achievedAt,
      active: calculation.milestoneEarnedBps > 0,
    },
    {
      label: '12个月/25%',
      date: milestoneAnniversary(milestone.achievedAt, 12),
      active: calculation.vestingPercent >= 25,
    },
    {
      label: '24个月/50%',
      date: milestoneAnniversary(milestone.achievedAt, 24),
      active: calculation.vestingPercent >= 50,
    },
    {
      label: '36个月/100%',
      date: milestoneAnniversary(milestone.achievedAt, 36),
      active: calculation.vestingPercent >= 100,
    },
    {
      label: '截至日',
      date: scenario.asOfDate,
      active: true,
    },
    {
      label: '终止日',
      date: scenario.terminationDate,
      active: scenario.agreementTerminated,
    },
  ];

  return (
    <section className="timeline-panel" aria-label="里程碑时间线">
      <div className="panel-heading">
        <span className="eyebrow">时间线</span>
        <h2>{milestone.shortTitle}</h2>
      </div>
      <div className="timeline-track">
        {nodes.map((node) => (
          <div className={`timeline-node ${node.active ? 'is-active' : ''}`} key={node.label}>
            <span className="node-dot" />
            <strong>{node.label}</strong>
            <span>{node.date ?? '未设置'}</span>
          </div>
        ))}
      </div>
      <p className="timeline-note">
        当前时间归属：{formatBps(calculation.timeVestedBps)}。当前可行权：
        {formatBps(calculation.exercisableBps)}。
      </p>
    </section>
  );
}
